import React from 'react';
import { motion } from 'framer-motion';
import { scrollToComprar } from '../utils';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="py-12 md:py-16 px-4 bg-white border-t border-cream-dark" data-id="element-80">
      <div className="max-w-4xl mx-auto text-center" data-id="element-81">
        <h2 className="font-display text-3xl md:text-5xl font-bold text-primary mb-4" data-id="element-82">
          Tu perro merece vivir más y mejor
        </h2>
        <p className="text-lg md:text-xl text-brown-light mb-8 max-w-2xl mx-auto" data-id="element-83">
          No dejes pasar esta oportunidad de darle la salud que se merece. La
          oferta con el 60% de descuento y los bonos gratuitos está por
          terminar.
        </p>

        <div className="mb-8" data-id="element-84">
          <CountdownTimer data-id="element-85" />
        </div>

        <button onClick={scrollToComprar} className="bg-accent hover:bg-accent-hover text-white font-bold text-xl py-5 px-10 rounded-xl shadow-lg transform transition hover:-translate-y-1 w-full sm:w-auto inline-block" data-id="element-86">
          SÍ, QUIERO APROVECHAR LA OFERTA
        </button>
      </div>
    </section>;
}